import {
  VehiculeForm
} from './vehicule-form/vehicule-form';
import {
  VehiculeService
} from './../../../providers/vehicule.service';
/*import {
  imagesDir
} from './../../../providers/global.config';*/
import {
  NavController,
  NavParams,
  AlertController,
  ModalController,
  LoadingController,
  ViewController,
  MenuController,
  ToastController
} from 'ionic-angular';
import {
  Component
} from '@angular/core';
import {
  DataManagementService
} from './../../../providers/data-management.service';
import {
  VehiculeInfo,
  DeviceLabel,
  DriverLabel,
  GroupLabel,
  Vehicule,
  Groupe,
  Driver
} from '../../../objects/index';

@Component({
  selector: 'page-vehicules',
  templateUrl: 'vehicules.html',
})
export class Vehicules {
  public bigCurrentPage: number = 1;
  itemsPerPage = 25;
  vehicules: VehiculeInfo[] = [];
  public bigTotalItems: number = 175;
  numberDeviceFree: number;
  deviceLabels: DeviceLabel[] = [];
  constructor(public menu: MenuController, public toastCtrl: ToastController, public modalCtrl: ModalController, public alertCtrl: AlertController, public navctrl: NavController, private vehiculeService: VehiculeService, ) {

  }
  //Get list groups and devices
  ngOnInit() {
    this.getListVehicules(this.bigCurrentPage - 1, this.itemsPerPage);
    this.vehiculeService.getGroupsLabel().subscribe(response => {
      this.vehiculeService.groupLabels = response;
    });
    this.vehiculeService.getDriversLabel().subscribe(response => {
      this.vehiculeService.driverLabels = response;
    });
    this.vehiculeService.getDevicesLabel().subscribe(response => {
      this.vehiculeService.deviceLabels = response;
      this.deviceLabels = response;
      this.numberDeviceFree = this.deviceLabels.length;
    });

  }
  openmenu() {
    this.menu.open();
  }
  //get list vehicules "pagination"
  getListVehicules(page: number, size: number) {
    this.vehiculeService.bigCurrentPage = this.bigCurrentPage;
    this.vehiculeService.getListVehicules(this.bigCurrentPage - 1, this.itemsPerPage).subscribe(response => {

      this.vehicules = response.content;
      this.vehicules = this.vehicules.sort((a, b) => {
        if (a.device.idDevice < b.device.idDevice) {
          return -1;
        } else if (a.device.idDevice > b.device.idDevice) {
          return 1;
        } else {
          return 0;
        }
      });
      this.vehiculeService.vehicules = this.vehicules;
      this.bigTotalItems = response.totalElements;
    });
  }
  //alert Modification
  presentConfirm(vehicule: any) {
    let alert = this.alertCtrl.create({
      title: 'Informations',
      message: 'Equipement:' + vehicule.device.idDevice + '<br> Vitesse Max :' + vehicule.maxSpeed + '<br> Chauffeur : ' + vehicule.lastName + '<br> Email :' + vehicule.emails + '<br> Surnom : ' + vehicule.alias + '<br> Marque : ' + vehicule.mark,
      buttons: [{
          text: 'Ok',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Modifier',
          role: '',
          handler: () => {
            this.openModifModal(vehicule)
          }
        }
      ]
    });
    alert.present();
  }
  //alert supprimer vehicule "non utilise"
  delete(vehicule: any) {
    let alert = this.alertCtrl.create({
      title: 'Attention',
      message: 'Voulez vous vraiment supprimer :' + vehicule.matricule + '?',
      buttons: [{
          text: 'Cancel',
          role: 'cancel',
          handler: () => {

          }
        },
        {
          text: 'Supprimer',
          handler: () => {
            this.deletevehicule(vehicule)
          }
        }
      ]
    });
    alert.present();
  }
  //methode de suppression
  deletevehicule(vehicule: any) {
    this.vehiculeService.delete(vehicule.idVehicule).subscribe((suprimed) => {
      if (suprimed) {
        if (this.vehicules.length == 1) {
          this.vehicules = [];
        } else {
          this.getListVehicules(this.bigCurrentPage - 1, this.itemsPerPage);
        }
        this.numberDeviceFree = this.numberDeviceFree + 1;
        let toast = this.toastCtrl.create({
          message: '' + vehicule.matricule + ' est supprimé avec succés',
          duration: 3000,
          position: 'top'
        });

        toast.present();
      } else {
        let toast = this.toastCtrl.create({
          message: 'suppresion échoué',
          duration: 3000,
          position: 'top'
        });
        toast.present();
      }
    }, () => {
      let toast = this.toastCtrl.create({
        message: 'suppresion échoué',
        duration: 3000,
        position: 'top'
      });
      toast.present();
    });
  }
  // modification modal "vehicule-form.ts"
  openModifModal(vehicule: any) {
    let PoiModal = this.modalCtrl.create(VehiculeForm, {
      vehicule
    });
    PoiModal.present();
    PoiModal.onDidDismiss(form => {})
  }
  //end
}



// WEBPACK FOOTER //
// ./src/pages/datamana/vehicules/vehicules.ts